import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PlanCompositeFormState {
  formValues: any;
  mainItems: any[];
  optionItems: any[];
  basePlan: {
    type?: string;
    transactionCategory?: string;
    paymentMethod?: string;
  };
}

const initialState: PlanCompositeFormState = {
  formValues: {},
  mainItems: [],
  optionItems: [],
  basePlan: {}
};

export const planCompositeFormSlice = createSlice({
  name: 'planCompositeForm',
  initialState,
  reducers: {
    savePlanCompositeForm: (state, action: PayloadAction<any>) => {
      return action.payload;
    },
    resetPlanCompositeForm: () => initialState
  }
});

export const { savePlanCompositeForm, resetPlanCompositeForm } =
  planCompositeFormSlice.actions;

export default planCompositeFormSlice.reducer;
